import { topicTags } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              全网瓜友最关注的话题标签，点击探索你感兴趣的内容
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicTags.map((tag, idx) => {
              const sizes = ['md', 'lg', 'sm', 'md', 'lg', 'sm', 'md', 'md', 'sm', 'sm', 'sm'];
              const sizeClass = sizes[idx] || 'md';
              const paddingClass = sizeClass === 'lg' ? 'px-6 py-3' : sizeClass === 'md' ? 'px-5 py-2.5' : 'px-4 py-2';
              const textClass = sizeClass === 'lg' ? 'text-base' : sizeClass === 'md' ? 'text-sm' : 'text-xs';

              return (
                <a
                  key={tag.name}
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className={`group ${paddingClass} rounded-full cursor-pointer transition-all duration-300 hover:scale-105 whitespace-nowrap ${
                    idx === 0
                      ? 'bg-primary-500 text-background-50'
                      : idx === 1
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 hover:bg-secondary-100 border border-background-200'
                  }`}
                >
                  <span className={`${textClass} font-medium`}>{tag.name}</span>
                  <span className={`ml-1.5 ${textClass} ${
                    idx === 0 || idx === 1
                      ? 'text-background-200'
                      : 'text-foreground-400'
                  }`}>
                    {tag.count}
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}